import React from 'react'

interface FilterIconProps {
	width?: number | string
	height?: number | string
	color?: string
	onClick?: () => void
	style?: React.CSSProperties
}

const FilterIcon: React.FC<FilterIconProps> = ({
	width = 16,
	height = 16,
	color = '#7F7F84',
	onClick,
	style,
}) => (
	<svg
		width={width}
		height={height}
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		onClick={onClick}
		style={{
			cursor: 'pointer',
			...style,
		}}
	>
		<path
			d='M11.3335 6L8.00016 2.66667L4.66683 6'
			stroke={color}
			strokeWidth='1.33333'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M11.3335 10L8.00016 13.3333L4.66683 10'
			stroke={color}
			strokeWidth='1.33333'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
)

export default FilterIcon
